export const mapShortenedFieldNames = (character) => {
  const mapped = { ...character };

  if ('upd' in mapped) {
    mapped.updated_at = mapped.upd;
    delete mapped.upd;
  }

  if ('user' in mapped) {
    mapped.creator_user_id = mapped.user;
    delete mapped.user;
  }

  if ('pers' in mapped) {
    mapped.personality_ids = mapped.pers;
    delete mapped.pers;
  }

  return mapped;
};
